<template>
    <keep-alive>

        <div class="container-fluid img-manager">
            <manager-options
                :selectedImagesLength="selectedImagesLength"
                @deleteSelectedImages="deleteImagesSelected(selectedImages)"
                @changeFilter="filterImage = $event"
                @changeDisplay="displayOptions = $event"
                @inSearch="inSearch = $event"
                @selectAllImages="selectAllImages"
                @removeImageSelection="removeImageSelection"
            />

            <dashboard
                :uppy="uppy"
                :plugins="['aws-s3', 'drop-target']"
                :props="{
                    theme: 'light',
                    width: '100%',
                    height: '80px'
                }"
            />

            <div :class="['listImages', !hasResults ? 'd-flex justify-content-center align-items-center listImages--none' : '']">
                <template v-if="displayOptions === 'icons'">
                    <MasonryDisplay
                        :masonryId="imagesMasonryGrid"
                        :media="images"
                        :isSelected="isSelected"
                        :inGallery="inGallery"
                        :manageMedia="manageMedia"
                        :deleteMedia="deleteImage"
                        :nameFormated="nameFormated"
                        @copyImageLink="copyLink($event)"
                        @copyVideoLink="copyLink($event)"
                    />
                </template>

                <template v-else>
                    <table-display
                        v-if="hasResults"
                        :items="images"
						:inGallery="inGallery"
                        :selectedMedias="selectedImages"
                        :selectedMediasLength="selectedImagesLength"
                        :deleteMedia="deleteImage"
                        :manageMedia="manageMedia"
                        :isSelected="isSelected"
                        @copyImageLink="copyLink($event)"
                        @copyVideoLink="copyLink($event)"
                    />
                </template>

                <template v-if="!hasResults">
					<empty-search-results :message="messageNotResult" :sub-message="subMessageNotResult" />
                </template>

                <template v-if="getNextMediaUrl" >
                    <infinite-loading @infinite="infiniteHandler" spinner="bubbles"></infinite-loading>
                </template>
            </div>

            <div v-if="this.$data.fileProgressShow">
                <FileProgress
                    :percentage="this.$data.uploadPercentage"
                    :filesTotal="this.$data.filesTotal"
                    :currentfile="this.$data.currentfile"
				/>
            </div>

			<div class="container-button">
				<button
					class="btn btn-primario btn-extra-large"
					id="imageManagerButton"
					:disabled="validateButton()"
					@click="sendImages()"
				>
					Adicionar
				</button>
			</div>
        </div>
    </keep-alive>
</template>


<script>
import InfiniteLoading from 'vue-infinite-loading';
import {mapGetters} from "vuex";

import userModule from "../../store/modules/userModule.js";

import uploadFiles from "@/mixins/uploadFiles";
import apiMixins, { getPresignedS3Url } from "@/mixins/apiMixins";

import { Dashboard } from '@uppy/vue'
import DropTarget from '@uppy/drop-target'
import Uppy from '@uppy/core'
import AwsS3 from '@uppy/aws-s3'

import FileProgress from "@/components/organisms/FileProgress";
import alertScreen from "@/components/molecules/AlertScreen";
import ManagerOptions from '../atoms/ImageManagerOptions.vue';

import MasonryDisplay from '../atoms/MasonryDisplay.vue';
import TableDisplay from '../atoms/TableDisplay.vue';
import EmptySearchResults from '../blocks/EmptySearchResults.vue';

import uppyLocalePtbrCustom from "@/utils/uppyLocalePtbrCustom.js";
import '@uppy/core/dist/style.css'
import '@uppy/dashboard/dist/style.css'
import '@uppy/drop-target/dist/style.css'


export default {
    name: 'ImageManager',
    components: {
        Dashboard,
		InfiniteLoading,
		FileProgress,
		alertScreen,
        ManagerOptions,
        EmptySearchResults,
        MasonryDisplay,
        TableDisplay
    },
	inject: ['picsInGallery', 'maxItemSelected'],
    data() {
        return {
			inSearch: false,
			messageNotResult: '',
			subMessageNotResult: '',
            selectedImages: [],
            imagesMasonryGrid: 'imagesMasonryGrid',
            hasResults: true,
            searchImages: '',
            filterImage: 'created_at-desc',
            displayOptions: 'icons',
            imagesInGallery: [],
            imageMasonryGrid: '',
			namesFiles: [],
        }
    },
  	mixins: [uploadFiles, apiMixins],
    methods: {
        makeToast(variant = null, title, content, ) {
            this.$bvToast.toast(content, {
                title,
                variant: variant,
                solid: true
            })
        },
		async copyToClipboard(string) {
                await navigator.clipboard.writeText(string);
		},
        async copyLink(itemRef) {
			if (itemRef.getOriginalUrl) {
				// chama o metodo getOriginalUrl dentro do componente baseImage
				const link = itemRef.getOriginalUrl();

				// copia para o clipboard
				try {
					await this.copyToClipboard(link);
					this.makeToast('success', 'Sucesso', 'Link copiado para a área de transferência.');
				} catch (error) {
					this.makeToast('danger', 'Erro', 'Falha ao copiar link, tente novamente.');
				}
			} else {
				try {
					await this.copyToClipboard(process.env.CDN_URL + itemRef.content);
					this.makeToast('success', 'Sucesso', 'Link copiado para a área de transferência.');
				} catch (error) {
					console.log(error);
					this.makeToast('danger', 'Erro', 'Falha ao copiar link, tente novamente.');
				}
			}
        },
        removeImageSelection() {
            this.selectedImages = [];
        },
        selectAllImages() {
			this.selectedImages = [];

            this.selectedImages = this.images.map((img, index) => ({
                id: img.id,
                url: img.content,
                dataCreate: img.datetime,
                index: index
            }))
		},
        isSelected(url) {
			let res = this.selectedImages.findIndex(img => img.url == url);
			if (res >= 0) {
				return true;
			} else {
				return false;
			}
		},
        manageMedia(post, index) {
			let res = this.selectedImages.findIndex(img => img.url == post.content);

			if (res >= 0) {
				this.selectedImages.splice(res, 1);
			} else {
				if (this.maxItemSelected && this.selectedImagesLength >= this.maxItemSelected) {
					this.makeToast('danger', 'Erro', `Você só pode selecionar ${this.maxItemSelected} imagens.`);
					return;
				}

				this.selectedImages.push({
					'id': post.id,
					'url': post.content,
					'width': post.width,
					'height': post.height,
					'dataCreate': post.datetime,
					'index': index
				});
			}
		},
        nameFormated(name) {
			var split = name.split(".");

			var name = '';

			if (window.innerWidth < 768) {
				name = split[0].length > 15 ? split[0].substr(0,10) + '...' : split[0] + '.';
			} else {
				name = split[0].length > 25 ? split[0].substr(0,20) + '...' : split[0] + '.';
			}

			var extenxion = split[1];

			return name + extenxion;
		},
        deleteImage(post, index){
			this.$bvModal
				.msgBoxConfirm("Deseja remover este item do gerenciador de mídias?", {
					modalClass: "full-white modal-delete-medias",
					size: "md",
					buttonSize: "sm",
					okTitle: "Excluir",
					cancelTitle: "Cancelar",
					footerClass: "p-2",
					hideHeaderClose: true,
					centered: true,
				})
				.then(async (value) => {
					if (value) {
						this.$store.dispatch("dashboardModule/TOGGLE_LOADING", [true]);

						var response = await this.deleteMedias([post]);

						if (response) {
							this.$store.state.userModule.mediaManager.medias.splice(index, 1);

							this.selectedImages.filter( (image) => {
								if (image.id == post.id) {
									this.selectedImages.splice(this.selectedImages.indexOf(image), 1);
								}
							});
						}

						this.$store.dispatch("dashboardModule/TOGGLE_LOADING", [false]);
					}
				});

		},
		async deleteImagesSelected(images){
			let message = this.selectedImagesLength > 1 ? `Excluir ${this.selectedImagesLength} mídias selecionadas?` : `Excluir 1 mídia selecionada?`;

			const modal = this.$bvModal
				.msgBoxConfirm(message, {
					modalClass: "full-white modal-delete-medias",
					size: "md",
					buttonSize: "sm",
					cancelVariant: "danger",
					okTitle: "Excluir",
					cancelTitle: "Cancelar",
					footerClass: "p-2",
					hideHeaderClose: true,
					centered: true,
				})
				.then(async (value) => {
					if (value) {

						var response = await this.deleteMedias(images);

						if (response) {
							images.forEach((image) => {
								this.$store.state.userModule.mediaManager.medias.filter((item) => {
									if (item.content == image.url) {
										this.$store.state.userModule.mediaManager.medias.splice(this.$store.state.userModule.mediaManager.medias.indexOf(item), 1);
									}
								});
							});

							this.selectedImages = [];
						}

						this.$store.dispatch("dashboardModule/TOGGLE_LOADING", [false]);

						this.getImages();
					}
				});
		},
        inGallery(url) {
			if (this.imagesInGallery) {
				let res = this.imagesInGallery.findIndex(img => img == url);
				if (res >= 0) {
					return true;
				} else {
					return false;
				}
			}
		},
        async infiniteHandler($state){
			if (this.getNextMediaUrl) {
				const newMedias = await this.requestApiData( this.getNextMediaUrl,  'get');
				if (newMedias.content.length > 0) {
					this.$store.dispatch("userModule/UPDATE_MEDIAS", [newMedias]);
					setTimeout(() => {
						$state.loaded();
					}, 1000);
				} else {
					this.$store.dispatch("userModule/END_MEDIA", false)
				}
			} else {
				$state.complete();
			}
		},
        getImages() {
			let token = this.$session.get("jwt");
			let siteId = this.$session.get("siteId");

			this.$store.dispatch("userModule/FILTERS_MEDIAS", [token, siteId, this.searchImages, this.filterImage]);
		},
        methodsUppy() {
            this.uppy.on('upload', () => {
                this.uploadFinish = false;
				this.$data.fileProgressShow = true;

				userModule.state.newImages = [];
            });

			this.uppy.on('files-added', (files) => {
				this.$data.filesTotal = files.length;
				this.$data.currentfile = 0;
			});

			this.uppy.on('progress', (progress) => {
				this.$data.uploadPercentage = progress;
			});

			this.uppy.on('upload-success', (file, response) => {
				this.$data.currentfile++;

				let url = response.body.location;
                url = url.replace(process.env.CONTAINER_URL, '');

				let id;

				userModule.state.newImages.map( (image) => {
					if (image.path == url) {
						image.source = "Banco de imagens";
						image.width = file.meta.width;
						image.height = file.meta.height;
						image.content = url;
						id = image.id;
					}
				});

				this.selectedImages.push({
					'url': url,
					'width': file.meta.width,
					'height': file.meta.height,
					'dataCreate': '',
					'id': id
				});
			});

			this.uppy.on('upload-error', (file, error) => {
				console.log('error:', error);
                console.log('file-error:', file);

				this.$data.fileProgressShow = false;
			});

			this.uppy.on('error', (file, error, response) => {
                console.log('error:', error);
                console.log('file-error:', file);
                console.log('response-error:', response);

				this.$data.fileProgressShow = false;

				return null;
			});

			this.uppy.on('complete', () => {
                this.uploadFinish = true;
				this.$data.fileProgressShow = false;

				document.querySelectorAll('.uppy-StatusBar-actionBtn--done')[0].click();

				this.$store.dispatch('userModule/UNSHIFT_UPLOADED_IMAGES', [userModule.state.newImages]);
            });
		},
		validateButton() {
			if (this.selectedImagesLength > 0) return false;
			return true;
		},
		sendImages() {
			// pegando componente pai (hierarquia de renderização) do VideoMager
			let tab = this.$parent

			// pegando componente pai (hierarquia de renderização) do Tab
			let tabs = tab.$parent

			// pegando componente pai (hierarquia de renderização) do Tabs
			let headerBTab = tabs.$parent

			// pegando componente pai (hierarquia de renderização) do HeaderBTab
			let mediaManager = headerBTab.$parent

			// Emitindo evento diretamente pelo componente MediaManager
            mediaManager.$emit("receiveMedias", this.selectedImages);
		},
		picsPosted(picsInGallery) {
			this.imagesInGallery = picsInGallery && picsInGallery.map(item => {
				const url = item.image ? item.image.url : item.mainImage;
				return url;
			});
		},
    },
    computed: {
        ...mapGetters("userModule", [
			"getMediaManagerMedias", "getMediaManagerMediasVideos", "getMediaManagerFilterOptions", "getNextMediaUrl", "getNextMediaUrlVideos",  "getMediaManagerStatus", "getMediaManagerLoading", "setNextMediaUrl",
		]),
        images() {
            return this.getMediaManagerMedias;
		},
        selectedImagesLength() {
            return this.selectedImages.length;
        },
        uppy() {
			return new Uppy({
				locale: uppyLocalePtbrCustom,
				id: 'uppyInstance',
				showSelectedFiles: false,
				autoProceed: true,
				restrictions: {
					allowedFileTypes: [
						'.jpg', '.jpeg', '.png', '.webp', '.gif'
					],
				},
			onBeforeFileAdded: (currentFile, files) => {
				let res = this.namesFiles.findIndex(name => name == currentFile.name);

				if (res >= 0) {
					const name = currentFile.name.replace('.' + currentFile.extension, '');
					currentFile.name =	name + '-' + Date.now() + '.' + currentFile.extension;

					return currentFile;
				}

				this.namesFiles.push(currentFile.name)

				return currentFile;
			}
			}).use(AwsS3, {
				limit: 5, // limite de uploads simultaneos
				timeout: 1 * 60 * 3000, // 1 * 60 * 1000 = 1 minutos
				allowedMetaFields: ['name'],
				async getUploadParameters(file) {
					// obtém a resolução da imagem
					const data = file.data;

					const url = URL.createObjectURL(data);

					const image = new Image();

					image.src = url;

					// tratando promise para não travar o upload
					await image.decode()
					.then(() => {

					})
					.catch((erro) => {
						console.error(erro);
					});

					const res = {
						width: image.width,
						height: image.height
					}

					// aqui tem que ser a chamada pra api pra receber a url pra fazer o upload ( getPresignedS3Url do apiMixins )
					let preSigned = await getPresignedS3Url(file, res.width, res.height);

					// atualiza o width e height da imagem que está sendo feito o upload
					file.meta.width = res.width;
					file.meta.height = res.height;

					// continuacao do upload
					if (preSigned && preSigned.data.success && preSigned.data.message.url != undefined) {

						userModule.state.newImages.push(preSigned.data.message.file);

						return {
							url: preSigned.data.message.url,
							method: 'put',
							fields: [],
							headers: {
								'Content-type': file.meta.type,
							}
						}
					}

					return null;
				}
			}).use(DropTarget, {
				target: document.body
			})
		},
    },
    mounted() {
        this.getImages();

		this.picsPosted && this.picsPosted(this.picsInGallery);
    },
    created() {
        this.methodsUppy();
    },
    beforeDestroy () {
        this.uppy.close({ reason: 'unmount' })
    },
    watch: {
        filterImage(newValue, oldValue) {
            newValue !== oldValue && this.getImages();
        },
        images(value) {
            if (this.images !== '' && value.length > 0 ) {
				this.hasResults = true;
			} else if (this.images !== '' && value.length == 0 && this.inSearch == true) {
                this.hasResults = false;
				this.messageNotResult = 'Nenhum resultado encontrado';
				this.subMessageNotResult = 'Experimente palavras-chave diferentes';
            } else if (this.images !== '' && value.length == 0 && this.inSearch == false) {
                this.hasResults = false;
				this.messageNotResult = 'Você não possui imagens ainda';
				this.subMessageNotResult = 'Arraste e solte arquivos aqui para fazer o envio';
            }
        }
    }
}
</script>

<style>
.img-manager {
    margin-top: 10.5rem;
}

.listImages--none {
    height: 60vh;
}

:root {
    --mediaManagerTheme: #7e7e7e;
    --mediaManagerThemeActive: #000000;
}

.uppy-Dashboard-AddFiles-title {
    position: relative;
    color: #7e7e7e;
}

.uppy-Root {
	top: 5px !important;
}

.uppy-Dashboard-AddFiles-list {
	display: none!important;
}

.uppy-Dashboard-AddFiles-title::before {
    content: url("../../assets/cloud-arrow-icon.svg");
    display: block;
    position: absolute;
    height: 22px;
    width: 32px;
    left: 50%;
    top: 0;
    transform: translateX(-50%);
}

button.uppy-Dashboard-browse {
    padding-top: 32px;
    color: #7e7e7e;
    transition: 200ms ease-out;
}
button.uppy-Dashboard-browse:hover {
    color: rgba(34, 117, 215, 0.9);
    transition: 200ms ease-in;
}

.fade-in{-webkit-animation:fade-in 2s cubic-bezier(.39,.575,.565,1.000) both;animation:fade-in 2s cubic-bezier(.39,.575,.565,1.000) both}
@-webkit-keyframes fade-in{0%{opacity:0}100%{opacity:1}}@keyframes fade-in{0%{opacity:0}100%{opacity:1}}

.grid-item {
    width: 16.6%;
	border: none !important;
}

.post-foto {
	border: 3px solid transparent;
	border-radius: 8px;
	transform: scale(0.97);
	transition: all 300ms;
}

.post-foto:hover {
	transform: scale(1);
}

.post-foto .in-post{
	height: 100%;
	width: 100%;
	position: absolute;
	top: 0rem;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: end;
    align-items: end;
    padding: 12px;
    border-radius: 4px;
}

.post-foto.active {
  	border: 3px solid var(--main-color);
}

.post-foto img {
	border-radius: 4px;
	cursor: pointer;
}

.post-foto .name-image-container {
	display: flex;
	align-items: center;
	justify-content: center;
	color: #fff;
	background-color: rgb(0, 0, 0, 0.4);
	border-radius: 1rem;
	margin: 0.5rem;
}

.post-foto .name-image-container span {
	font-size: 0.7rem;
	padding: 0.2rem 0.5rem;
}

.post-foto:hover .name-image-container {
	display: none !important;
}

.post-foto .delete-image-container {
	display: none;
}

.post-foto:hover .delete-image-container {
	display: block !important;
}

@media screen and (max-width: 576px) {
    .grid-item {
        width: 50%;
    }

    .listImages--none {
        height: 70vh;
    }
}

.container-button {
	position: fixed;
	bottom: 0;
	left: 0;
	right: 0;
	padding: 20px 10px;
	display: flex;
	justify-content: center;
	align-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/ImageManager.vue